module.exports = __webpack_public_path__ + "static/media/Stellar King Drawer Bed Base - 180x210 cm_Natural.3a0b63a9.png";